const isInYear = (date: string | undefined | null, year: string): boolean => date != null && date.includes(year);

const isInDateRange = (date: string | undefined | null, filterStartDate: string, filterEndDate: string): boolean =>
  date != null && date >= filterStartDate && date <= filterEndDate;

const filter = {
  isInYear,
  isInDateRange,
};

export default filter;
